var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoubandongkou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_25_5814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4777"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 662",
    d: "M10.0625 2.46875L1.4292 7.62979L6.625 13.5625L15.5705 7.37065L10.0625 2.46875Z",
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 85",
    cx: 6.90532,
    cy: 8.87914,
    rx: 1.92583,
    ry: 1.18301,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 86",
    cx: 9.88259,
    cy: 6.29615,
    rx: 1.24489,
    ry: 0.76472,
    fill: "white",
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_5814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoubandongkou);
export default __webpack_public_path__ + "static/media/loubandongkou.897d5d65a35515c64f87deb25b970a7c.svg";
export { ForwardRef as ReactComponent };